// import Popconfirm from "antd/es/popconfirm";
// import Button from "antd/es/button";
import Alert from "antd/es/alert";
import React from "react";
import ReactPlayer from "react-player/youtube";
// import http from "../utils/http";
import BkpmLogo from '../../src/assets/bkpm-logo-new.png';
import OssLogo from '../../src/assets/oss-logo-new.png';
import InfoRed from '../../src/assets/info-red.png';
import ExpiredImage from '../../src/assets/expired-image.png'

export default function ExpiredPage() {

    return (
        <div className="wrapper">
            <div className="inqueue" style={{
                boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)"
            }}>
                <div className="inqueue-body">
                    {process.env.REACT_APP_LINK_VIDEO_ID ? (
                        <ReactPlayer
                            url={`https://www.youtube.com/watch?v=${process.env.REACT_APP_LINK_VIDEO_ID}`}
                            loop={true}
                            controls={false}
                            width={"100%"}
                            height={"250px"}
                            playing={true}
                        />
                    ) : process.env.REACT_APP_LINK_LOGO ? (
                        // <img
                        //   src={process.env.REACT_APP_LINK_LOGO}
                        //   style={{
                        //     width: "100%",
                        //     height: 150,
                        //     objectFit: "contain",
                        //     marginTop: 10,
                        //     marginBottom: 10,
                        //   }}
                        //   alt="Logo BKPM"
                        // />
                        <div className="App-Card-Header" style={{
                            justifyContent: "center",
                            gap: 100
                        }}>
                            <div className="App-Image">
                                <img
                                    src={BkpmLogo}
                                    alt="Logo"
                                    style={{
                                        maxHeight: "100%",
                                        maxWidth: "100%",
                                    }}
                                />
                            </div>
                            <div className="App-Logo">
                                <img
                                    src={OssLogo}
                                    alt="Logo"
                                    style={{
                                        maxHeight: "100%",
                                        maxWidth: "100%",
                                    }}
                                />
                            </div>
                        </div>
                    ) : null}

                    <div style={{ textAlign: "center" }}>
                        <h5 style={{ fontWeight: 600 }}>Selamat datang di layanan video call Kementerian Investasi dan Hilirisasi/BKPM</h5>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ width: "30%", }}>
                                <img src={ExpiredImage} alt="Waiting" style={{ maxWidth: "100%", maxHeight: "100%" }} />
                            </div>
                        </div>
                        <div
                            className="label-status"
                            style={{
                                background: "#D6D5D7",
                                color: "#C61824",
                            }}
                        >
                            Jadwal Telah Kadaluarsa
                        </div>
                    </div>
                    <div className="inqueue-wording">
                        <div
                            style={{
                                display: "flex"
                            }}
                        >
                            <div className="col-text" style={{ width: "100%" }}>
                                Bapak/Ibu yang kami hormati, jadwal konsultasi video call yang telah ditetapkan untuk Anda saat ini sudah melewati waktu yang ditentukan. <br />
                                Jika Bapak/Ibu masih memerlukan layanan konsultasi, kami dengan senang hati akan membantu. <br />
                                Silakan mengajukan penjadwalan ulang melalui platform yang tersedia atau menghubungi layanan kami melalui :
                                <div style={{ display: "flex", justifyContent: "center", gap: 20, margin: "10px 0" }}>
                                    <h6
                                        style={{
                                            margin: 0,
                                            fontSize: "11px",
                                            fontWeight: 400
                                        }}
                                    >
                                        <span style={{ fontWeight: 600 }}>Email: </span>
                                        kontak@oss.go.id
                                    </h6>
                                    <h6
                                        style={{
                                            margin: 0,
                                            fontSize: "11px",
                                            fontWeight: 400
                                        }}
                                    >
                                        <span style={{ fontWeight: 600 }}>Whatsapp: </span>
                                        08116774642
                                    </h6>
                                    <h6
                                        style={{
                                            margin: 0,
                                            fontSize: "11px",
                                            fontWeight: 400
                                        }}
                                    >
                                        <span style={{ fontWeight: 600 }}>Instagram: </span>
                                        @oss.go.id
                                    </h6>
                                    <h6
                                        style={{
                                            margin: 0,
                                            fontSize: "11px",
                                            fontWeight: 400
                                        }}
                                    >
                                        <span style={{ fontWeight: 600 }}>Call Center: </span>
                                        169
                                    </h6>
                                </div>
                                Hormat Kami,<br />
                                Kementerian Investasi dan Hilirisasi/BKPM
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{
                    borderTop: "3px solid #D90915"
                }}>
                    <Alert
                        style={{
                            background: "#DADADA",
                            padding: "20px 30px",
                            textAlign: "center",
                        }}
                        message={
                            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                                <div style={{ width: "20px" }}>
                                    <img src={InfoRed} alt="Info" style={{ maxWidth: "100%", maxHeight: "100%" }} />
                                </div>
                                <span
                                    style={{
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        // fontStyle: "italic",
                                    }}
                                >
                                    Guna meningkatkan kualitas layanan, panggilan video ini akan direkam. Dilarang untuk merekam dan/atau menyebarluaskan audio dan gambar. <br/>Pelanggaran akan ditindak sesuai dengan peraturan perundang-undangan yang berlaku.
                                </span>
                            </div>
                        }
                        banner
                        showIcon={false}
                    />
                </div>
            </div>
        </div>
    );
}
